import { Spinner } from 'apps/shared/scripts/components';

import { iconClassName, spinnerClassName } from './styles';

const CheckoutLoading = () => {
  return <Spinner className={spinnerClassName} iconClassName={iconClassName} />;
};

CheckoutLoading.displayName = 'CheckoutLoading';

export default CheckoutLoading;
